import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ReportService } from '../../_services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalDataService } from '../../_shared';
import { EnterVoWD, Supplier, Report, DropAmtComnt, LoginUser , CostCenter} from '../../_models';
import { ModalPopupAlertComponent } from '../../_shared/modal-popup-alert/modal-popup-alert.component';
import { SpinnerService } from '../../_shared/spinner/spinner.service';
import * as XLSX from 'xlsx'; 
import * as ExcelJS from 'exceljs';
import { Subscription, Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
@Component({
  standalone: false,
  selector: 'app-drop-analysis',
  templateUrl: './drop-analysis.component.html',
  styleUrls: ['./drop-analysis.component.css']
})
export class DropAnalysisComponent implements OnInit {
  ChkAll: any =false;
  ChkOne: any =false;
  config: any;
  rptData = new Report();
  dropAmtComnt = new DropAmtComnt();
  CostCentersResult: CostCenter[] = [];
   SupplierAB!: string ;
   SupName = ''; 
   DropID=0;
   ObjectAccount = '';  
   ObjectAccountDesr = ''; 
   Area?: string;
  Department?: string ;
  arrayListArea: Array<string> = [];
  arrayListDepartment: Array<string> = [];
  arrayListAreaDistinct: Array<string> = [];
  arrayListDepartmentDistinct: Array<string> = [];
   Year = '';  
   cmd = 'DROP';
   Month='';
   Drop!:any;
   ExistingDrop!:any;
   FractionDrop:number[] = [];
   Adjust!:number;
   DropComments='';
   Remarks='';
  dropAnalysisResult: any[] = [];
  resVowdList: any[] = [];
  dropAnalysisView = new EnterVoWD();
  suppliersResult: Supplier[] = [];
  objectAccountsResult: string[] = [];
  getMonths: string[] = [];
  getYrs : string[]=[];
  user: LoginUser = new LoginUser;
  flgLock: boolean = false;
  flag: boolean = false; // newly added
  subscription: Subscription = new Subscription;
   DropsAdjumntSum!: number;
   PendingAccural!: number;
   results!: Observable<Supplier[]>;  
   loading: boolean = true;
   resultsObj!: Observable<string[]>; 
  private searchTermsObj = new Subject<string>();  
  FrmDt!: string | number | Date;
  ToDt: any ;
  ApprDt!: { year: number; month: number; day: number; };
  arrayList: Array<string> = [];
  @ViewChild('TABLE', { static: false })
  TABLE!: ElementRef;  
  title = 'Excel';  
  errDrop: boolean = false;
  errDropCmt: boolean = false;
  vowdTotal: number=0;
  vowdInv: number=0;
  vowdAdj: number=0;
  vowdDrp: number=0;
  vowdOvp: number=0;
  vowdAccr: number=0;
  Droptxt: boolean = false;
  Adjustmentxt: boolean = true;
  DictDrop: any = new Map<number,number>();
  DictAdjust:any =  new Map<number,number>();
  DictFracDrop:any = new Map<number,number>();

  constructor(
    private reportService  : ReportService,
    private gd : GlobalDataService,
    private modalService: NgbModal,
    private spinnerService: SpinnerService
  ){ }

  async ExportTOExcel() {
    try {
      // Create new ExcelJS workbook
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Accrual_Calculation');

      // Define columns with header text, data key and whether they are numeric
      const columns: { header: string; key: string; numeric: boolean; text?: boolean }[] = [
        { header: 'Provisioning ID',                          key: 'CreatedBy',                              numeric: false },
        { header: 'Supplier AB#',                             key: 'SupplierAB',                             numeric: false },
        { header: 'Supplier Name',                            key: 'SupplierName',                           numeric: false },
        { header: 'Object Account',                           key: 'ObjDescr',                               numeric: false },
        { header: 'Month/Year',                               key: 'Period',                                 numeric: false },
        { header: 'Cost Center',                              key: 'CostCenter',                             numeric: false },
        { header: 'Division Field',                           key: 'DivisionField',                          numeric: false },
        { header: 'Company Code',                             key: 'CompanyCode',                            numeric: false },
        { header: 'Area',                                     key: '_area',                                  numeric: false },
        { header: 'Department',                               key: 'Division',                               numeric: false },
        { header: 'VOWD Amount',                              key: 'VOWDAmount',                             numeric: true  },
        { header: 'SmartbyGEP Requisition #',                 key: 'SmartbyGEP_Requisition',                 numeric: false },
        { header: 'SmartbyGEP Service Consumption Date',      key: 'SmartbyGEP_Service_Consumption_Date',    numeric: false },
        { header: 'SmartbyGEP Service Start Date',            key: 'SmartbyGEP_Service_Start_Date',          numeric: false },
        { header: 'SmartbyGEP Service Complete Date',         key: 'SmartbyGEP_Service_Complete_Date',       numeric: false },
        { header: 'SmartbyGEP Requisition Amount',            key: 'SmartbyGEP_Requisition_Amount',          numeric: true  },
        { header: 'SmartbyGEP Supplier Invoice Number',       key: 'SmartbyGEP_Invoice',                     numeric: false, text: true },
        { header: 'SmartbyGEP Invoice Date',                  key: 'SmartbyGEP_Invoice_Date',                numeric: false },
        { header: 'SmartbyGEP Invoice Amount',                key: 'SmartbyGEP_Invoice_Amount',              numeric: true  },
        { header: 'SmartbyGEP Invoice Number',                key: 'SmartbyGEP_DocumentID',                  numeric: false },
        { header: 'SmartbyGEP Service Confirmation Number',   key: 'SmartbyGEP_Service_Confirmation_Number', numeric: false },
        { header: 'Contract ID',                              key: 'ContractID',                             numeric: false },
        { header: 'Successful to JDE',                        key: '_successfulToJDE',                       numeric: false },
        { header: 'JDE Invoice Number',                       key: 'JDE_Invoice',                            numeric: false, text: true },
        { header: 'JDE Purchase Order #',                     key: 'JDE_PurchaseOrder',                      numeric: false },
        { header: 'JDE Invoice Date',                         key: 'JDE_Invoice_Date',                       numeric: false },
        { header: 'GLDate',                                   key: 'GLDate',                                 numeric: false },
        { header: 'JDE Invoice Amount',                       key: 'JDE_Invoice_Amount',                     numeric: true  },
        { header: 'JDE Invoice Status',                       key: 'JDE_Invoice_Status',                     numeric: false },
        { header: 'Invoice',                                  key: 'Invoice',                                numeric: true  },
        { header: 'JDE Actuals',                              key: 'JDE_Actual_Amount',                      numeric: true  },
        { header: 'Adjustment',                               key: 'Adjustment',                             numeric: true  },
        { header: 'Drops',                                    key: 'Drops',                                  numeric: true  },
        { header: 'Overpayments',                             key: 'Overpayments',                           numeric: true  },
        { header: 'Accrual',                                  key: 'Accrual',                                numeric: true  },
      ];

      const totalCols = columns.length;

      // Merge first two rows for title
      worksheet.mergeCells(1, 1, 2, totalCols);
      const titleCell = worksheet.getCell('A1');
      titleCell.value = 'Accrual Calculation Report';
      titleCell.fill   = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } };
      titleCell.font   = { color: { argb: 'FF022954' }, size: 18, name: 'Aptos Narrow', bold: true };
      titleCell.border = {
        top: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }
      };
      titleCell.alignment = { vertical: 'middle', horizontal: 'left' };

      // Write header row (row 3)
      columns.forEach((col, i) => {
        const cell = worksheet.getCell(3, i + 1);
        cell.value = col.header;
        cell.fill   = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF022954' } };
        cell.font   = { color: { argb: 'FFFFFFFF' }, size: 12, name: 'Calibri', bold: true };
        cell.border = {
          top: { style: 'thin', color: { argb: 'FF000000' } }, left: { style: 'thin', color: { argb: 'FF000000' } },
          bottom: { style: 'thin', color: { argb: 'FF000000' } }, right: { style: 'thin', color: { argb: 'FF000000' } }
        };
        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      });

      // Write data rows starting at row 4 directly from dropAnalysisResult
      this.dropAnalysisResult.forEach((row, rowIdx) => {
        columns.forEach((col, colIdx) => {
          const cell = worksheet.getCell(4 + rowIdx, colIdx + 1);
          cell.font = { size: 12, name: 'Calibri' };

          let rawValue = row[col.key];

          // Computed/derived fields
          if (col.key === '_area') {
            cell.value = `${row['Area_Code'] || ''}-${row['Area_description'] || ''}`;
            return;
          }
          if (col.key === '_successfulToJDE') {
            cell.value = row['SuccessfultoJDE'] ? 'Yes' : 'No';
            return;
          }

          if (col.numeric) {
            // Parse and store as actual number so Excel treats it as numeric
            // Leave cell empty if value is null, undefined or empty string
            if (rawValue === null || rawValue === undefined || rawValue === '') {
              cell.value = null;
            } else {
              const num = parseFloat(rawValue);
              cell.value = isNaN(num) ? null : num;
              if (cell.value !== null) cell.numFmt = '#,##0.00';
            }
          } else if (col.text) {
            // Force text to prevent scientific notation on long numbers
            cell.value = rawValue != null ? rawValue.toString() : '';
          } else {
            cell.value = rawValue != null ? rawValue : '';
          }
        });
      });

      worksheet.autoFilter = { from: { row: 3, column: 1 }, to: { row: 3, column: totalCols } };

      worksheet.views = [{
        state: 'frozen',
        ySplit: 3,
        xSplit: 0
      }];

      // Set column widths
      worksheet.columns.forEach((column) => { column.width = 18; });

      // Set row heights for title
      worksheet.getRow(1).height = 25;
      worksheet.getRow(2).height = 25;
      
      // Generate Excel file as buffer
      const buffer = await workbook.xlsx.writeBuffer();
      
      // Download the file using manual method
      const blob = new Blob([buffer], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });
      
      const fileName = 'AccrualCalc' + new Date().toDateString() + '_' + new Date().getTime().toString() + '.xlsx';
      
      // Manual download without file-saver
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
            
    } catch (error) {
      console.error('Error using ExcelJS:', error);
      //this.exportTableToExcel();
    }
  }

  ngOnInit() {
    this.user = this.gd.getUserData();
    this.Droptxt = false;
    this.Adjustmentxt = true;
    this.getSuppliers();
    this.getObjectAccount();
    this.getCenterData();
    this.getMonths = this.gd.monthNames;
    this.Month = this.gd.monthNames[new Date().getMonth()];
    this.getAcurlYr();
    this.GetApprovedDate()
  }
  
  GetApprovedDate(){
    this.reportService.getApprovedDate().subscribe(res => {
      if(res!=null)
      {
        this.ApprDt = {
          "year": new Date(res.ApproveDate).getFullYear(),
          "month":  new Date(res.ApproveDate).getMonth()+1,
          "day": new Date(res.ApproveDate).getDate()
        }
      }
    });
  }
  getCenterData()
  {
    this.CostCentersResult= this.gd.getCostCenterData();
    this.arrayListArea = this.CostCentersResult.map(cost => cost.Area_CODE +"-" +cost.Area_description); 
    this.arrayListDepartment = this.CostCentersResult.map(cost =>cost.Division); 
    this.arrayListAreaDistinct = this.arrayListArea.filter((n, i) => this.arrayListArea.indexOf(n) === i);
    this.arrayListDepartmentDistinct = this.arrayListDepartment.filter((n, i) => this.arrayListDepartment.indexOf(n) === i);
  }
  searchArea = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.arrayListAreaDistinct.filter(v => v!=null && v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  )

  searchDepartment = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.arrayListDepartmentDistinct.filter(v => v!=null && v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  )
  getSuppliers()
  {
   
    this.suppliersResult= this.gd.getSupplierData();
    this.arrayList = this.suppliersResult.map(sup => sup.SupplierAB.toString().trim() +"-" +sup.SupplierName.toString().trim()); 
  }

  searchSupplier = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.arrayList.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  )

  searchObjectAcnt = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.objectAccountsResult.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  )
  
  
  selectedAll(chk :boolean) {
     for (var i = 0; i < this.dropAnalysisResult.length; i++) {
       this.dropAnalysisResult[i].selected = chk;
     }
   }

  selectedOne(dropAnalysis : any) {
    this.ChkOne=this.ChkOne==false ? true :false;
    this.CalculateAccural(dropAnalysis,this.ChkOne);
  }

  getDropAnanlysis(type:string)
  {
    this.PrepareReportData();
    if(type=='search')
    {
         this.ChkAll =false;
         this.DictDrop.clear();
         this.DictAdjust.clear();
         this.DictFracDrop.clear();
         this.getDropAmtComnt();
    }
    if(type=='calc')
    {
     
        if(this.DropComments.length < 20)
          this.errDropCmt =true;
        else{
          this.resVowdList=this.dropAnalysisResult.filter(t=>t.selected == true);
          if(this.resVowdList.length>0)
          {            
            this.vowdDrp =0;this.vowdAccr=0;
            if(this.resVowdList.length==1){
              var temp = this.ConvertToInt(Number(Math.round(parseFloat(this.resVowdList[0].Accrual + 'e' + 2)) + 'e-' + 2).toFixed(2));
             
              if(temp > 0.00 && this.resVowdList[0].VOWDAmount > 0.00){
                this.ExistingDrop = this.resVowdList[0].Drops ;
                if(!this.Droptxt)
                {
                  this.Remarks = 'Drop';
                  if(this.Drop < temp){
                    this.resVowdList[0].Drops = (this.ConvertToInt(this.Drop) + this.ConvertToInt(this.ExistingDrop) );
                    if(this.DictDrop.has(this.resVowdList[0].AccrualID)){
                      this.DictDrop.set(this.resVowdList[0].AccrualID, this.DictDrop.get(this.resVowdList[0].AccrualID) + this.ConvertToInt(this.Drop));
                    }
                    else{
                      this.DictDrop.set(this.resVowdList[0].AccrualID,this.ConvertToInt(this.Drop));
                    }
                  }
                  else{
                    this.resVowdList[0].Drops = this.ConvertToInt(temp) + this.ConvertToInt(this.ExistingDrop) ;
                    if(this.DictDrop.has(this.resVowdList[0].AccrualID)){
                      this.DictDrop.set(this.resVowdList[0].AccrualID, this.DictDrop?.get(this.resVowdList[0]?.AccrualID) + this.ConvertToInt(temp));
                    }
                    else{
                      this.DictDrop.set(this.resVowdList[0].AccrualID,this.ConvertToInt(temp));
                    }
                  }
                  
                }else
                {
                  this.Remarks = 'Adjustment';
                  if (this.Adjust < temp){
                    this.resVowdList[0].Drops = this.ConvertToInt(this.Adjust) + this.ConvertToInt(this.ExistingDrop);
                    if(this.DictAdjust.has(this.resVowdList[0].AccrualID)){
                      this.DictAdjust.set(this.resVowdList[0].AccrualID, this.DictAdjust.get(this.resVowdList[0].AccrualID) + this.ConvertToInt(this.Adjust));
                    }
                    else{
                      this.DictAdjust.set(this.resVowdList[0].AccrualID,this.ConvertToInt(this.Adjust));
                    }
                  }
                  else{
                    this.resVowdList[0].Drops = this.ConvertToInt(temp) + this.ConvertToInt(this.ExistingDrop) ;
                    if(this.DictDrop.has(this.resVowdList[0].AccrualID)){
                      this.DictDrop.set(this.resVowdList[0].AccrualID, this.DictDrop.get(this.resVowdList[0].AccrualID) + this.ConvertToInt(temp));
                    }
                    else{
                      this.DictDrop.set(this.resVowdList[0].AccrualID,this.ConvertToInt(temp));
                    }
                  }
                }
              
                let accrualRes = ( this.resVowdList[0].VOWDAmount -this.resVowdList[0].Invoice -this.resVowdList[0].Adjustment-this.resVowdList[0].Drops);
                this.resVowdList[0].Accrual= accrualRes < 0 ? 0 : accrualRes;
                this.resVowdList[0].Remarks = this.Remarks;
                
              } 
              else{
                debugger
                if(this.resVowdList[0].VOWDAmount > 0.00){
                  this.openAlertModal("Cannot add drop/adjustment further for the selected record.")
                }
                else{
                  this.openAlertModal("VoWD is not submitted for the selected record.")
                }
              }
            }
            else{
                  var sumOfVOWD=0; var sumOfInvoice=0;
                  for(let i=0; i < this.resVowdList.length;i++){
                    sumOfVOWD =sumOfVOWD + this.resVowdList[i].VOWDAmount;
                    sumOfInvoice =sumOfInvoice +this.resVowdList[i].Invoice;
                  
                  } 
                  var absDiff = Math.abs(sumOfVOWD-sumOfInvoice);
                  var dropValue = this.Droptxt ? this.Adjust : this.Drop ;
                  var perDrop = ((dropValue/absDiff)*100) ;
                  for(let i=0; i < this.resVowdList.length;i++)
                  {
                    if (this.DictFracDrop.has(this.resVowdList[i].AccrualID))
                      this.DictFracDrop.set(this.resVowdList[i].AccrualID, this.DictFracDrop.get(this.resVowdList[i].AccrualID) + this.ConvertToInt((this.resVowdList[i].Accrual * perDrop)/100));       
                    else
                      this.DictFracDrop.set(this.resVowdList[i].AccrualID, this.ConvertToInt((this.resVowdList[i].Accrual * perDrop)/100));
                  
                    this.resVowdList[i].Drops=  this.ConvertToInt(((this.resVowdList[i].Accrual * perDrop)/100)) + this.ConvertToInt(this.resVowdList[i].Drops); 
                    let accrual =( this.resVowdList[i].VOWDAmount -this.resVowdList[i].Invoice -this.resVowdList[i].Adjustment-this.resVowdList[i].Drops); 
                    this.resVowdList[i].Accrual= accrual <0 ?0:accrual;
                    this.resVowdList[i].Remarks = this.Droptxt ? 'Adjustment' : 'Drop' ;
                  
                  } 
              }
              for (let i=0;i<this.dropAnalysisResult.length;i++)
              {
                this.vowdDrp = (this.vowdDrp + this.dropAnalysisResult[i].Drops) ;
                this.vowdAccr = (this.vowdAccr + this.dropAnalysisResult[i].Accrual) ;
              }
            this.CalcDropAmtComnt();   
            
          }
          else
          {
            this.openAlertModal("Please Select Record To be drop");
            return;
          }
         
        
          this.errDrop =false;
          this.errDropCmt =false;
        }  
    
    }
  
  }
  SearchDropAnalysisReport()
  {
    this.loading = true;
    this.spinnerService.Spinner('show');
    this.reportService.getAllDropAnalysisSearch(this.rptData).subscribe(data=>{
      this.dropAnalysisResult = data;
      console.log(this.dropAnalysisResult);
      this.vowdTotal=0;this.vowdInv=0;this.vowdAdj=0;this.vowdDrp=0;this.vowdOvp=0;this.vowdAccr=0;
      for (let i=0;i<this.dropAnalysisResult.length;i++)
      {
        this.vowdTotal =(this.vowdTotal + this.dropAnalysisResult[i].VOWDAmount) ;
        this.vowdInv = (this.vowdInv + this.dropAnalysisResult[i].Invoice) ;
        this.vowdAdj = (this.vowdAdj + this.dropAnalysisResult[i].Adjustment) ;

        this.vowdDrp = (this.vowdDrp + this.dropAnalysisResult[i].Drops) ;
        this.vowdOvp = (this.vowdOvp + this.dropAnalysisResult[i].Overpayments) ;
        this.vowdAccr = (this.vowdAccr + this.dropAnalysisResult[i].Accrual) ;
        this.dropAnalysisResult[i].ObjDescr = this.objectAccountsResult.filter(t=>t.split('-')[0].trim()== this.dropAnalysisResult[i].ObjectAccount.trim())[0];
      }
     
      this.config = {
        itemsPerPage: 10,
        currentPage: 1,
        totalItems: this.dropAnalysisResult.length
      };
      this.loading = false;
      this.spinnerService.Spinner('hide');
      });
      this.subscription = this.gd.flgVOWDLock$.subscribe(
        flgVOWDLock => this.flgLock = flgVOWDLock
        );
  }

  PrepareReportData()
  {
    this.rptData.supplierAB=(this.SupplierAB==null || this.SupplierAB.trim()=='')?0: parseInt(this.SupplierAB.split('-')[0]);
   
    this.rptData.objectAccount=this.ObjectAccount;
    this.rptData.area=(this.Area==null||this.Area=='')? null:this.Area.split('-')[0];
    this.rptData.department=(this.Department==null||this.Department=='')? null:this.Department;
    this.rptData.year =  new Date(this.FrmDt).getFullYear().toString() ;//this.Year;
    this.rptData.FromDate = this.gd.convertToStandardDate(this.FrmDt);
    this.rptData.ToDate = this.gd.convertToStandardDate(this.ToDt);
     this.rptData.cmd = "" //Report visiblity change to all users
    this.rptData.ApprDate = this.gd.convertToStandardDate(this.ApprDt);
 
  }
   
  
   
  onselectSupplier(SupObj :Supplier) {     
    if (SupObj.SupplierAB != 0) {  
      this.SupplierAB = SupObj.SupplierAB.toString();
      this.SupName = SupObj.SupplierName +"-("+ SupObj.SupplierAB +")";  
      this.loading = false;  
      return true;
    }  
    else {  
      return false;  
    }
  }

  getDropAmtComnt()
  {
    this.reportService.getDropAmtComnt(this.rptData).subscribe(data=>{
      if(data !=null)
      {
      this.dropAmtComnt = data;
      this.Drop = this.dropAmtComnt.DropAmt;
      this.DropComments = this.dropAmtComnt.DropComments ;
      }
      this.rptData.Drop = this.dropAmtComnt.DropAmt;
      this.SearchDropAnalysisReport();
    });
  }
  CalcDropAmtComnt()
  {
    this.dropAmtComnt.DropAmt=this.Drop;
    this.dropAmtComnt.DropComments = this.DropComments;
    this.rptData.Drop = this.dropAmtComnt.DropAmt;
  }
  getAcurlYr()
  {
   
    for (var i = 2000; i <= 2040; i++) {
      this.getYrs.push(i.toString());
    }
    this.Year = new Date().getFullYear().toString();
  }

  getObjectAccount()
  {
    this.objectAccountsResult=this.gd.getAccountData();
   
   }

   // Push a search term into the observable stream.  
   searchObjAcnt(term: string): void {  
    if(term.length < 2)
    {
    this.getObjectAccount();
    }
      this.loading = true;  
      this.searchTermsObj.next(term); 
  }  
  
 onselectObjAcnt(ObjAcnt :string) {     
   if (ObjAcnt != '') {  
    this.ObjectAccount =ObjAcnt.split('-')[0].toString();
    this.ObjectAccountDesr =ObjAcnt; 
     this.loading = false;  
     return true;
   }  
   else {  
     return false;  
   }
 }



  OnSubmit(){
      this.reportService.updateDropAnalysis(this.resVowdList).subscribe(data=>{
        this.SubmitDropsComment();
        this.openAlertModal("Record Saved Successfully")
        this.DictDrop.clear();
        this.DictAdjust.clear();
        this.DictFracDrop.clear();
      },
      error=>{
        
      }
      );
  }

SubmitDropsComment(){
    if(this.resVowdList.length == 1){
    for(var i=0;i<=this.resVowdList.length-1;i++)
    {
      this.dropAmtComnt.SupplierAB=(this.resVowdList[i]['SupplierAB']);
      this.dropAmtComnt.ObjectAccount=this.resVowdList[i]['ObjDescr'];
      this.dropAmtComnt.SupName=this.resVowdList[i]['SupplierABName'];
      this.dropAmtComnt.Period=this.resVowdList[i]['Period'];
      if(!this.Droptxt){
        this.dropAmtComnt.DropAmt=this.DictDrop.get(this.resVowdList[i].AccrualID);
      }
      else{
        this.dropAmtComnt.DropAmt=this.DictAdjust.get(this.resVowdList[i].AccrualID);
      }      
      this.dropAmtComnt.Area=this.resVowdList[i]['Area_Code']+"-"+this.resVowdList[i]['Area_description'];
      if(this.dropAmtComnt.Remarks == this.resVowdList[i]['Remarks'] || this.dropAmtComnt.Remarks == "undefined" || this.dropAmtComnt.Remarks == "" )
      {
        this.dropAmtComnt.DropID = 0;
      }
      else
      {
        this.dropAmtComnt.DropID = 0;
      }
      this.dropAmtComnt.Remarks = this.resVowdList[i]['Remarks'];
      
      this.dropAmtComnt.FromDate =this.gd.convertToStandardDate(this.FrmDt);
      this.dropAmtComnt.ToDate =this.gd.convertToStandardDate(this.ToDt);
      this.dropAmtComnt.CreatedBy= this.user.ProvisioningID;      
      this.reportService.AddDropAmtComnt(this.dropAmtComnt).subscribe(data=>{
      },
      error=>{
       
      }
      );
  }
}
else{
  for(var i=0;i<=this.resVowdList.length-1;i++)
{
  this.dropAmtComnt.SupplierAB=(this.resVowdList[i]['SupplierAB']);
  this.dropAmtComnt.ObjectAccount=this.resVowdList[i]['ObjDescr'];
  this.dropAmtComnt.SupName=this.resVowdList[i]['SupplierABName'];
  this.dropAmtComnt.Period=this.resVowdList[i]['Period'];  
  this.dropAmtComnt.DropAmt=this.DictFracDrop.has(this.resVowdList[i].AccrualID) ? this.DictFracDrop.get(this.resVowdList[i].AccrualID) : 0; 
 
  this.dropAmtComnt.Area=this.resVowdList[i]['Area_Code']+"-"+this.resVowdList[i]['Area_description'];
  if(this.dropAmtComnt.Remarks == this.resVowdList[i]['Remarks'] || this.dropAmtComnt.Remarks == "undefined" || this.dropAmtComnt.Remarks == "" )
    {
      this.dropAmtComnt.DropID = 0;
  }else
      {
        this.dropAmtComnt.DropID = 0;
      }
      this.dropAmtComnt.Remarks = this.resVowdList[i]['Remarks'];
         
          this.dropAmtComnt.FromDate =this.gd.convertToStandardDate(this.FrmDt);
          this.dropAmtComnt.ToDate =this.gd.convertToStandardDate(this.ToDt);
          this.dropAmtComnt.CreatedBy= this.user.ProvisioningID;      
          this.reportService.AddDropAmtComnt(this.dropAmtComnt).subscribe(data=>{
        },
        error=>{
        
        });
      }
    }
}
  
  openAlertModal(strmsg: string) {
    const modalRef = this.modalService.open(ModalPopupAlertComponent);
    modalRef.componentInstance.strText = strmsg;
    modalRef.result.then((result) => {
    }, (reason) => {
    });   
  }

  CalculateAccural(dropAnalysis : any, checked:boolean) {
      this.reportService.CalculateAccural(dropAnalysis).subscribe(data=>{
      
        let itemIndex = this.dropAnalysisResult.findIndex(item => item.AccrualID == dropAnalysis.AccrualID);
        this.dropAnalysisResult[itemIndex] = data;
        this.dropAnalysisResult[itemIndex].selected = checked;
      });

    
  }
  
  pageChanged(event: any){
    this.config.currentPage = event;
  }

  EnableText(){
    this.Droptxt = !this.Droptxt;
    this.Adjustmentxt = !this.Adjustmentxt;
    if(this.Droptxt)
    {
      this.Drop = 0;
    }
    if(this.Adjustmentxt)
    {
      this.Adjust = 0;
    }
  }

  ConvertToInt(val: any){
    return parseFloat(val);
  }

  isDefined(value:any) {return typeof value !== 'undefined';}

  // Method to format invoice number columns as text to prevent scientific notation
  private formatInvoiceColumnsAsText(ws: XLSX.WorkSheet) {
    try {
      if (!ws['!ref']) return;
      
      const range = XLSX.utils.decode_range(ws['!ref']);
      
      // Define only the specific columns that should be formatted as text
      const textColumnPatterns = [
        'JDE Invoice Number',
        'SmartbyGEP Invoice #'
      ];
      
      // Get header row to identify column positions
      const headerRow = 0; // First row (0-indexed)
      const columnMap: { [key: string]: number } = {};
      
      // Map column names to their positions
      for (let col = range.s.c; col <= range.e.c; col++) {
        const cellAddress = XLSX.utils.encode_cell({ r: headerRow, c: col });
        const cell = ws[cellAddress];
        if (cell && cell.v) {
          const headerText = cell.v.toString().trim();
          textColumnPatterns.forEach(pattern => {
            if (headerText.toLowerCase().includes(pattern.toLowerCase()) || 
                headerText === pattern) {
              columnMap[pattern] = col;
            }
          });
        }
      }
      
      // Format identified columns as text
      Object.values(columnMap).forEach(colIndex => {
        for (let row = range.s.r + 1; row <= range.e.r; row++) { // Skip header row
          const cellAddress = XLSX.utils.encode_cell({ r: row, c: colIndex });
          const cell = ws[cellAddress];
          if (cell && cell.v !== undefined && cell.v !== null) {
            // Convert to text format to preserve full numbers and prevent scientific notation
            cell.t = 's'; // Set cell type to string
            cell.v = cell.v.toString(); // Ensure value is string
            cell.z = '@'; // Set number format to text
            delete cell.w; // Remove formatted value to force recalculation
          }
        }
      });
     
    } catch (error) {
      console.error('Error formatting invoice columns:', error);
    }
  }
}
